import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription, Observable } from "rxjs";
import { ProductService } from "src/app/shared/services/product.service";
import { OrderService } from "src/app/shared/services/order.service";
import { interval } from "rxjs";

@Component({
  selector: "app-order-success",
  templateUrl: "./order-success.component.html",
  styleUrls: ["./order-success.component.scss"],
})
export class OrderSuccessComponent implements OnInit, OnDestroy {
  paymentMethod: string;
  cicodOrderId: string;
  amount: number;
  customerEmail: string;
  ussdCodes: any = [];
  banks: any = [];
  paymentUssd: string;
  subscription: Subscription;
  showBank: boolean = true;
  orderId: number;
  sub: Subscription;
  paymentStatus: string;
  changePayment: boolean;

  constructor(
    private route: ActivatedRoute,
    private productService: ProductService,
    private orderService: OrderService,
    private router: Router
  ) {}

  ngOnInit() {
    this.getPaymentDetails();
    this.getUSSDCodes();

    this.sub = interval(10000).subscribe((x) => {
      this.checkOrderPaymentStatus();
      if (this.paymentStatus === "PAID") {
        this.router.navigate(["/payment"], {
          queryParams: {
            paymentStatus: "success",
          },
        });
        this.sub.unsubscribe();
        return;
      }
    });
  }

  changePaymentMethod(){
    this.paymentMethod = "";
    this.changePayment = true;
  }
  setNewPaymentMethod(paymentMethod : string){
    this.paymentMethod = paymentMethod ;
    this.changePayment = false;
  }

  getBankCode(bankId) {
    const bnk = this.banks.filter((bank) => bank.id == bankId);
    this.paymentUssd = bnk[0].code;
    this.showBank = false;
  }
  getUSSDCodes() {
    this.productService.getUSSD().subscribe(
      (data) => {
        this.ussdCodes = data.data;
        this.banks = this.ussdCodes.map((b, i) => ({
          id: i + 1,
          name: b.bank_name,
          code: b.cicod_code,
        }));
      },
      (err) => {
        console.log(err);
      }
    );
  }

  changeBank() {
    this.paymentUssd = "";
  }

  checkOrderPaymentStatus() {
    this.orderService.checkOrderStatus(this.orderId).subscribe(
      (data) => {
        this.paymentStatus = data.data.payment_status;
        // console.log(this.paymentStatus);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getPaymentDetails() {
    this.subscription = this.route.queryParamMap.subscribe((param) => {
      this.paymentMethod = param.get("paymentMethod");
      this.cicodOrderId = param.get("cicodOrderId");
      this.amount = +param.get("amount");
      this.customerEmail = param.get("email");
      this.orderId = +param.get("oid");
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
